export function canPatientInitiateNewConversation(patient) {
  return patient?.allowPatientInitiateMessaging === true;
}

export function canPatientViewConversation(conversation, patientId) {
  if (!patientId || !conversation || conversation.isStaffOnly) return false;
  return Array.isArray(conversation.usersId) && conversation.usersId.includes(patientId);
}

export function canPatientRespondToConversation(conversation, patientId) {
  return Boolean(conversation?.conversationId) && canPatientViewConversation(conversation, patientId);
}
